import script from "./ProjectDocuments.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectDocuments.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectDocuments.vue?vue&type=style&index=0&id=6fc8b024&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fc8b024"]])

export default __exports__